import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useDirect, useTheme } from "../hooks";
import { CustomDialog, CustomToast, Theme } from "../component";
import router from "./router";
import { useEffect } from "react";
import keyNames from "../keyName";
import { useSelector } from "react-redux";
import CustomDrawer from "../component/drawer";

const Layout = () => {
  const themes = useTheme();
  const directDispatch = useDirect();
  const storeData = useSelector((state) => state.mainReducer);
  const { forceLogOut } = storeData;
  useEffect(() => {
    if (forceLogOut) {
      directDispatch(false, keyNames.forceLogOut);
      if (sessionStorage.authToken) {
        window.location.href = "/";
      }
      sessionStorage.removeItem("authToken");
    }
  }, [forceLogOut, directDispatch]);
  return (
    <ThemeProvider theme={themes}>
      <Theme />
      <CustomToast />
      <CustomDialog />
      <CustomDrawer />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};
export default Layout;
